import { styled, Typography } from "@mui/material";
import {
  JWTErrorCause,
  sessionStorage,
} from "../../dataAccess/storages/session";
import { useNavigateSameTab } from "../../helpers/navigation";
import { pageMapping } from "../../builder/mapping/page";
import { useConfiguration } from "../../dataAccess/api/configuration";
import { ThemeButton } from "./ThemeComponents/ThemeButton";
import { TextButton } from "./TextButton";
import { useUser } from "../../dataAccess/api/user";
import { useTranslation } from "../../helpers/i18n";
import { useIntercom } from "../../app/useIntercom";

const Main = styled("div")(() => ({
  display: "flex",
  height: "100%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "1rem",
}));

const ButtonsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "1rem",
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: "1.5rem",
  letterSpacing: "0.2rem",
  fontSize: theme.typography.h2.fontSize,
  textAlign: "center",
  textTransform: "uppercase",
  opacity: "0.3",
}));

const StyledText = styled(Typography)(() => ({
  maxWidth: "30rem",
  textAlign: "center",
  lineHeight: "1.3",
}));

const UnderlineButton = styled(TextButton)(() => ({
  textDecoration: "underline",
  marginTop: "0.5rem",
}));

const AuthenticationFailed = () => {
  const { t } = useTranslation();
  const { push: navigate } = useNavigateSameTab();
  const { show } = useIntercom();
  const { configuration } = useConfiguration();
  const { jwtAuthenticationError } = useUser();

  async function onTryAgain(url: string) {
    if (configuration?.ssoSetting.forceJwtAuth) {
      navigate(configuration.ssoSetting.signInRedirectUrl);
    } else {
      await navigate(url);
      sessionStorage.setjwtAuthenticationError(null);
    }
  }

  const messages: Partial<Record<JWTErrorCause, string>> = {
    [JWTErrorCause.MISSMATCH_INVITATION_EMAIL]: t(
      "information_jwt_invitation_wrong_email",
    ),
  };

  return (
    <Main>
      <Title variant="h1">{t("information_jwt_auth_failed")}</Title>
      <StyledText>
        {messages[jwtAuthenticationError?.cause || JWTErrorCause.UNKNOWN] ||
          t("information_jwt_try_again_contact_us")}
      </StyledText>
      <ButtonsContainer>
        <ThemeButton
          onClick={() =>
            onTryAgain(jwtAuthenticationError?.link || pageMapping.Login.path)
          }
        >
          {t("information_try_again")}
        </ThemeButton>
        {show && (
          <UnderlineButton onClick={show}>
            {t("information_contact_us")}
          </UnderlineButton>
        )}
      </ButtonsContainer>
    </Main>
  );
};

export default AuthenticationFailed;
